/* BOGO test page: the buy box price line names the offer for the current quantity.
   zappy.js writes "N × $X per card" on every quantity change; this rewrites it after. */
(function () {
  'use strict';
  var OFFERS = { 3: 'Buy 2, Get 1 FREE', 5: 'Buy 3, Get 2 FREE', 10: 'Buy 5, Get 5 FREE', 20: 'Buy 10, Get 10 FREE' };
  document.querySelectorAll('[data-buybox]').forEach(function (root) {
    var el = root.querySelector('[data-price-unit]');
    if (!el) return;
    var apply = function () {
      var q = parseInt(root.dataset.qty || root.dataset.defaultQty, 10) || 1;
      var label = OFFERS[q] || el.textContent;
      if (OFFERS[q] && el.textContent !== label) el.textContent = label;
    };
    new MutationObserver(apply).observe(el, { childList: true, characterData: true, subtree: true });
    new MutationObserver(apply).observe(root, { attributes: true, attributeFilter: ['data-qty'] });
    apply();
  });
})();
